import { render } from "./UINavBar.vue?vue&type=template&id=02d76e40"
import script from "./UINavBar.vue?vue&type=script&lang=js"
export * from "./UINavBar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__